<template>
	<div class="component" :class="lowerCaseName">
		<component
			:class="className"
			:is="computedComponent"
			:fields="component?.fields"
			:rendering="component"
			v-if="!isRecognizedComponent"
		/>
		<div v-else>
			<pre>{{ computedComponent }}</pre>
		</div>
	</div>
</template>
<script setup>
const props = defineProps({
	component: { type: Object, required: true },
});

const lowerCaseName = computed(
	() => "component--" + (props.component?.componentName || "").toLowerCase()
);
const computedComponent = resolveComponent(props.component.componentName);
const isRecognizedComponent = computed(
	() => typeof computedComponent === "string"
);
const className = computed(() => props.component?.params?.class || undefined);
</script>
